import React from "react";
import CustomModal from "..";
import { useTranslation } from "react-i18next";
import { IoClose } from "react-icons/io5";
import useAuth from "../../../hooks/useAuth";

export const languagesJSON = [
  {
    nome: "English",
    id: "en",
    flag: "🇺🇸",
  },
  {
    nome: "中文(简体)",
    id: "zh",
    flag: "🇨🇳",
  },
  {
    nome: "Espanhol",
    id: "es",
    flag: "🇪🇸",
  },
  {
    nome: "Frances",
    id: "fr",
    flag: "🇫🇷",
  },
  {
    nome: "Deutsch",
    id: "de",
    flag: "🇩🇪",
  },
  {
    nome: "Português",
    id: "pt-BR",
    flag: "🇧🇷",
  },
  {
    nome: "Portugal",
    id: "pt-PT",
    flag: "🇵🇹",
  },
  {
    nome: "Italiano",
    id: "it",
    flag: "🇮🇹",
  },

  {
    nome: "Nederlands",
    id: "nl",
    flag: "🇳🇱",
  },
  {
    nome: "Türk",
    id: "tr",
    flag: "🇹🇷",
  },
  {
    nome: "Polski",
    id: "pl",
    flag: "🇵🇱",
  },
  {
    nome: "Русский",
    id: "ru",
    flag: "🇷🇺",
  },
  {
    nome: "Ελληνικά",
    id: "gr",
    flag: "🇬🇷",
  },
  {
    nome: "Magyar",
    id: "hu",
    flag: "🇭🇺",
  },
  {
    nome: "Bahasa Indonesia",
    id: "id",
    flag: "🇮🇩",
  },
  {
    nome: "日本語",
    id: "ja",
    flag: "🇯🇵",
  },
  {
    nome: "Čeština",
    id: "cs",
    flag: "🇨🇿",
  },
  {
    nome: "Român",
    id: "ro",
    flag: "🇷🇴",
  },
];

export default function ChangeLanguageModal({ visible, setVisible }) {
  const { t, i18n } = useTranslation();
  const { user, updateUser } = useAuth();
  const handleClose = () => {
    setVisible(false);
  };

  const handleChangeLanguage = (lang) => {
    updateUser({ id: user.id_usuario, set_language: lang });
    i18n.changeLanguage(lang);
    handleClose();
    localStorage.setItem("SPICY_LANG", lang);
  };

  return (
    <CustomModal
      className="flex flex-col justify-center items-center w-full h-full"
      visible={visible}
      handleClose={handleClose}
    >
      <div className="bg-[--gender-background] rounded-lg p-4 w-full">
        <div className="w-full">
          <div className="flex justify-between items-center mb-2">
            <h2 className="font-semibold flex-1">{t("textLanguage1")}</h2>
            <button
              className="touchable-opacity p-1 pe-4 pt-4 -me-4 -mt-4"
              onClick={handleClose}
            >
              <IoClose size={22} />
            </button>
          </div>
          <div className="scroll h-[calc(var(--vh_,_1vh)*100-150px)]">
            <div className="flex flex-col w-full">
              {languagesJSON.map((language) => {
                return (
                  <button
                    className="w-full touchable-opacity border-t"
                    key={language.id}
                    onClick={() => handleChangeLanguage(language.id)}
                  >
                    <div className="flex pb-2 pt-2">
                      <span className="flex-1 text-left">{language.nome}</span>
                      <span>{language.flag}</span>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
}
